function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import text from '../../text';
export var NO_DATA_MODAL = 'NO_DATA_MODAL';
var NoDataModal = function(props) {
    var onCancel = function(event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        props.onHide();
    };
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        centered: true
    }, props), /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h2", null, "3D Data not in database")), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, "We currently do not have any 3D Data available in the database for the location you specified."), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, "Please contact us to discuss your needs with a salesperson."), /*#__PURE__*/ React.createElement("div", {
        className: "form-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        href: "".concat(process.env.LARKI_MARKETING_URL, "/contact-us"),
        type: "button",
        target: "_blank",
        onClick: props.onHide
    }, text('contactUs')), /*#__PURE__*/ React.createElement("a", {
        name: "cancel",
        href: "#",
        onClick: onCancel
    }, text('cancel'))))));
};
export default NoDataModal;
